import { loadReportsById } from "lib/api/rideReports";
import { VOTING_ACTIVE } from "lib/utils";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { VotePageContainer } from "../";
import { SingleReportContainer } from "../SingleReport";
const history = window.history;

export class VotePageRouter extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reportId: (history.state && history.state.reportId) || null,
    };
  }

  componentDidMount() {
    if (!VOTING_ACTIVE) {
      this.props.history.push("/ride_reports/");
      return;
    }
    window.addEventListener("popstate", this.onPopState);

    // more efficient code for when we only have 10 finalists:
    // const {finalistIds, loadReportsById, reports} = this.props
    // const missingIds = finalistIds.filter(id => !reports.has(id))
    // if (missingIds.length > 0) {
    //   loadReportsById(missingIds)
    // }
    this.loadAllReports();
  }

  loadAllReports = () => {
    const { finalistIds, loadReportsById } = this.props;

    for (let i = 0; i < Math.ceil(finalistIds.length / 20); i++) {
      const slice = finalistIds.slice(20 * i, 20 * i + 20);
      loadReportsById(slice);
    }
  };

  onChangeRoute = (reportId) => {
    // title is ignored by current implementations. Weird.
    this.props.history.pushState({ reportId }, "", window.location.href);
    this.setState({ reportId }, () => window.scrollTo(0, 0));
  };

  onPopState = (e) => {
    const reportId = (e.state && e.state.reportId) || null;
    this.setState({ reportId }, () => window.scrollTo(0, 0));
  };

  render() {
    const { reportId } = this.state;
    if (reportId) {
      return <SingleReportContainer reportId={reportId} onChangeRoute={this.onChangeRoute} />;
    }
    return <VotePageContainer onChangeRoute={this.onChangeRoute} />;
  }
}

const mapStateToProps = (state) => ({
  reports: state.rideReports.reports,
  finalistIds: state.rolloutContest.finalistIds,
});

const mapDispatchToProps = {
  loadReportsById,
};

export const VotePageRouterContainer = connect(mapStateToProps, mapDispatchToProps)(withRouter(VotePageRouter));
